// Libs
import Vue from "vue";
import VeeValidate from "vee-validate";
import cssVars from "css-vars-ponyfill";

// глобальная регистрация базовых компонентов
import "@/components/_globals";

// Plugins
import vuetify from "@/plugins/vuetify";
import themes from "@/plugins/themes";

import "@mdi/font/css/materialdesignicons.css";

// Mixins
import Mess from "@/mixins/Mess";
import Locale from "@/mixins/Locale";
import SiteColors from "@/mixins/SiteColors";
import UserType from "@/mixins/UserType";
import PriceType from "@/mixins/PriceType";

// Utils
import { getTheme } from "@/utils/get-theme";
import getLocale from "@/utils/get-locale";
import detectBrowser from "@/utils/detect-browser";
import changeTheme from "@/__dev_utils__/change-theme";

if (detectBrowser() === "ie") {
  document.body.classList.add("browser-ie");
  cssVars();
}

Vue.use(VeeValidate);
Vue.mixin(Mess);
Vue.mixin(Locale);
Vue.mixin(SiteColors);
Vue.mixin(UserType);
Vue.mixin(PriceType);

Vue.config.productionTip = false;

const createApp = (App, store, router) => {
  new Vue({
    vuetify,
    store,
    router,
    created() {
      this.$vuetify.lang.current = getLocale().slice(0, 2);

      if (process.env.NODE_ENV === "development") {
        window._changeTheme = theme => {
          changeTheme(theme);
          this.$vuetify.theme.themes.light = getTheme(theme, themes);
        };
      }
    },
    mounted() {
      console.debug("Building app");
      console.log(window.theme);
    },
    render: h => h(App)
  }).$mount("#app");
};

export { createApp };
